import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Common } from "@src/styles/Common";
import React, { Dispatch, SetStateAction, useState } from "react";
import { useJoinBenefitsList } from "@src/hooks/queries/useExpertDetail";

interface BenefitsProductProps {
    selectedItem: any;
    setSelectedItem: Dispatch<SetStateAction<any>>;
}

const BenefitsProduct = ({ selectedItem, setSelectedItem }: BenefitsProductProps) => {
    const [filterSearch, setFilterSearch] = useState<string>("");
    const keyword = filterSearch.trim();

    const onChangeSearchHandler = (e: any) => {
        setFilterSearch(e.target.value);
    };

    const { data } = useJoinBenefitsList(keyword || undefined);
    const list = Array.isArray(data) ? data : [];

    return (
        <>
            <StyledProductWrapper>
                <div className={"filterBox"}>
                    <label>검색</label>
                    <input
                        type="text"
                        value={filterSearch}
                        onChange={onChangeSearchHandler}
                        placeholder={"상품명 및 상품코드"}
                    />
                </div>
                <ul css={searchResultList}>
                    {list.map((item: any, idx: number) => (
                        <li
                            key={idx}
                            className={"subItems"}
                            onClick={() => {
                                setSelectedItem(item);
                            }}
                        >
                            <input
                                type={"radio"}
                                id={`item${idx}`}
                                name={"item"}
                                checked={selectedItem?.no === item?.no}
                                readOnly
                            />
                            <label htmlFor={`item${idx}`}>
                                <ul className="subItem">
                                    {item?.product?.name && (
                                        <li>
                                            <div className="header">상품명</div>
                                            <span className="text">{item.product.name}</span>
                                        </li>
                                    )}
                                    <li>
                                        <div className="header">혜택명</div>
                                        <span className="text">{item?.title ?? "-"}</span>
                                    </li>
                                    {item?.product?.code && (
                                        <li>
                                            <div className="header">상품코드</div>
                                            <span className="text">{item.product.code}</span>
                                        </li>
                                    )}
                                    {item?.product && (
                                        <li>
                                            <div className="header">정가</div>
                                            <span className="text">{`${
                                                item.product.term1DiscountedPrice?.toLocaleString() || 0
                                            }원`}</span>
                                        </li>
                                    )}
                                    {item?.product && (
                                        <li>
                                            <div className="header">할인가(판매가)</div>
                                            <span className="text">
                                                {`${item.product.term2DiscountedPrice?.toLocaleString() || 0}원`}
                                            </span>
                                        </li>
                                    )}
                                </ul>
                            </label>
                        </li>
                    ))}
                    {list.length === 0 && <li className="noData">조회된 혜택 상품이 없습니다.</li>}
                </ul>
            </StyledProductWrapper>
        </>
    );
};

export default BenefitsProduct;

const StyledProductWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 25px;
    font-weight: 400;
    font-size: 13px;
    color: #000000;

    & > div {
        display: flex;
        gap: 50px;
        & > .title {
            width: 50px;
        }
        & > .code {
            font-weight: 600;
        }
    }
    .filterBox {
        align-items: center;
        justify-items: center;
        gap: 0;
        & > label {
            width: 80px;
        }
        & > div {
            display: flex;
            gap: 5px;
            margin-left: 10px;
            cursor: pointer;
        }
        & > input[type="text"] {
            margin-left: 10px;
            width: 200px;
        }
    }
`;

const searchResultList = css`
    height: 100%;
    min-height: 280px;
    max-height: 320px;
    overflow: scroll;
    .noData {
        margin-top: 20px;
        height: 400px;
        text-align: center;
        padding-top: 25%;
        ${Common.textStyle.body3_R14}
        background-color: rgba(0,0,0,0.1);
        display: block;
    }
    .subItems {
        border-bottom: 1px solid ${Common.colors.gray100};
        &:first-of-type {
            margin-top: 10px;
        }
        input {
            display: none;
        }
    }
    input[type="radio"]:checked + label {
        display: block;
        width: 100%;
    }
    input[type="radio"]:checked + label > ul {
        background-color: rgba(154, 73, 242, 0.15);
    }
    .subItem {
        padding-top: 20px;
        padding-bottom: 20px;
        cursor: pointer;
        div {
            margin-bottom: 15px;
            span:first-of-type {
                text-indent: 10px;
                display: inline-block;
                width: 40%;
                color: ${Common.colors.gray600};
                ${Common.textStyle.title6_R14}
            }
            span:last-of-type {
                display: inline-block;
                width: 60%;
                ${Common.textStyle.title5_M14}
            }
            &:last-of-type {
                margin-bottom: 0;
            }
        }
        li {
            padding-left: 20px;
            margin-bottom: 10px;
            display: flex;
            &:last-of-type {
                margin-bottom: 0;
            }
        }
        .header {
            color: ${Common.colors.gray600};
            ${Common.textStyle.title6_R14}
            width: 100px;
            margin-right: 100px;
        }
        .text {
            ${Common.textStyle.title5_M14}
        }
    }
`;
